export default __webpack_public_path__ + "static/max-1-8483a7ba24cb11b718826221c077ec45.png";